import PropTypes from 'prop-types';
import React, { Component } from 'react';

import Iframe from './Iframe';

const isSSR = typeof window === 'undefined';

const HtmlSrcPath = '/html/2b2e4b_d767b483cae16e027c4ea8ac7906fbf4.html';

class IframeHtml extends Component {
  state = { shouldRender: false };

  id = Math.random().toString(36).substr(2, 9);

  componentDidMount() {
    this.setState({ shouldRender: true });
    !isSSR && window.addEventListener('message', this.handleIframeMessage);
  }

  componentWillUnmount() {
    !isSSR && window.removeEventListener('message', this.handleIframeMessage);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.html !== nextProps.html) {
      this.updateIframeContent(nextProps.html);
    }
  }

  updateIframeContent = content => {
    this.shouldIgnoreLoad = true;
    this.iframe?.contentWindow.postMessage(
      { type: 'htmlPlugin:updateContent', id: this.id, content },
      '*'
    );
  };

  handleIframeMessage = ({ data }) => {
    const { type, id, height } = data;
    if (type === 'htmlPlugin:heightResize' && id === this.id) {
      this.props.onHeightChange(height);
    }
  };

  handleIframeLoad = () => {
    !this.shouldIgnoreLoad && this.updateIframeContent(this.props.html);
  };

  render() {
    const { iframeSandboxDomain, isViewer } = this.props;

    const strippedUrl = iframeSandboxDomain.replace(/\/$/, '');

    return this.state.shouldRender ? (
      <Iframe
        style={{ backgroundColor: 'transparent' }}
        onLoad={this.handleIframeLoad}
        iframeRef={iframe => (this.iframe = iframe)}
        isViewer={isViewer}
        src={strippedUrl + HtmlSrcPath}
      />
    ) : null;
  }
}

IframeHtml.propTypes = {
  html: PropTypes.string.isRequired,
  onHeightChange: PropTypes.any,
  iframeSandboxDomain: PropTypes.string,
  isViewer: PropTypes.bool,
};

export default IframeHtml;
